module.exports = __webpack_public_path__ + "media/images/flags/32/Tajikistan-dab46fc2bf293b707e420efba0e1116b.png";